export default __webpack_public_path__ + "static/SRF Carasweet 5SG7806 - Product Specifications & Technical Data-9bd78dfc821c8dd43787194f9d1a15b3.pdf";